import { render, staticRenderFns } from "./NotificationTimeline.vue?vue&type=template&id=500fbb48&scoped=true&"
import script from "./NotificationTimeline.vue?vue&type=script&lang=ts&"
export * from "./NotificationTimeline.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationTimeline.vue?vue&type=style&index=0&id=500fbb48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500fbb48",
  null
  
)

export default component.exports